import * as angular from 'angular';
import {IController} from "angular";
import {FulfillmentStepModel} from "../../models/fulfillment-step.model";
import {FulfillmentService} from "../../services/fulfillment-service.service";
import {FulfillmentStepActionType} from "../../types/fulfillment-step-action.type";

export class FulfillmentStepsActionFooterComponent implements IController {
  selectedSteps: FulfillmentStepModel[];
  allowSendToPlanning: boolean;
  isExcludeMode: boolean;
  allowRestore: boolean;
  onBulkSendToDispatch: Function;
  onCompleteStepsManually: Function;
  onAssignAgentToServices: Function;
  onAutoAssignServices: Function;
  onAddServicesToRoute: Function;
  onAddServicesToResource: Function;
  onResetServices: Function;
  onCancelSteps: Function;
  onCancelServices: Function;
  onCreateVoucher: Function;
  onSendToPlanning: Function;
  onMultiAssignServices: Function;
  onRestoreFulfillments: Function;
  onClose: Function;

  public actions: any;
  public fulfillmentStepActionType: typeof FulfillmentStepActionType = FulfillmentStepActionType;
  public isSuperOwner: boolean;

  constructor(private fulfillmentService: FulfillmentService, private IAMPermissions) {
  }

  $onInit() {
    this.isSuperOwner = this.IAMPermissions.hasRole('super.owner');
    if (this.selectedSteps) {
      this._initActions();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.selectedSteps && !changes.selectedSteps.isFirstChange()) {
      if (this.selectedSteps) {
        this._initActions();
      }
    }
  }

  private _initActions() {
    this.actions = this.fulfillmentService.fulfillmentsActions(this.selectedSteps);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsActionFooter', {
    bindings: {
      selectedSteps: '<',
      isExcludeMode: '<',
      allowSendToPlanning: '<',
      allowRestore: '<?',
      onCompleteStepsManually: '&',
      onBulkSendToDispatch: '&',
      onAssignAgentToServices: '&',
      onAutoAssignServices: '&',
      onMultiAssignServices: '&',
      onAddServicesToRoute: '&',
      onAddServicesToResource: '&',
      onResetServices: '&',
      onCancelSteps: '&',
      onCancelServices: '&',
      onCreateVoucher: '&',
      onSendToPlanning: '&',
      onRestoreFulfillments: '&',
      onClose: '&'
    },
    template: require('./fulfillment-steps-action-footer.html').default,
    controller: FulfillmentStepsActionFooterComponent
  });
